import { Directive, ElementRef, Input, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import { HighlightService } from './highlight.service';

@Directive({
  selector: '[irdHighlight]',
})
export class HighlightDirective implements OnChanges {
  @Input('irdHighlight') searchText: string = '';

  private ranges: Range[] = [];

  constructor(
    private el: ElementRef<any>,
    private highlightService: HighlightService,
    private zone: NgZone,
  ) {
    this.zone.onStable.subscribe(() => {
      this.search();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.search();
  }

  private search() {
    this.clearRanges();

    if (this.searchText) {
      const element: HTMLElement = this.el.nativeElement;

      this.searchChildNodes(element);
    }
  }

  private searchChildNodes(element: HTMLElement) {
    Array.from(element.childNodes).forEach((child: HTMLElement) => {
      if (child.nodeType === Node.TEXT_NODE) {
        this.searchTextNode(child);
      } else if (child.childNodes.length > 0) {
        this.searchChildNodes(child);
      }
    });
  }

  private searchTextNode(textNode: HTMLElement) {
    const text = textNode.textContent || '';
    const regex = new RegExp(this.escapeRegex(this.searchText), 'gi');
    let match: RegExpExecArray | null;

    while ((match = regex.exec(text)) !== null) {
      this.ranges.push(this.highlightService.add(textNode, match.index, match.index + match[0].length));
    }
  }

  private escapeRegex(text: string): string {
    return text.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  private clearRanges() {
    this.ranges.forEach((range: Range) => {
      this.highlightService.delete(range);
    });
  }
}
